module.exports = __webpack_public_path__ + "img/foto-juliana-camargo.jpg";